import distributorReducer from './distributors';
export * from './distributors';

export default { distributor: distributorReducer };
